import { render, staticRenderFns } from "./EmptyView.vue?vue&type=template&id=28b6df5b&"
import script from "./EmptyView.vue?vue&type=script&lang=js&"
export * from "./EmptyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports